exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 600px;\r\n  width: 900px;\r\n  flex: 1;\r\n}\r\n\r\n.info-text {\r\n  padding: 10px;\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./Scripts/app/shared/appointment-list.component.css
// module id = 2466
// module chunks = 1